if (!window.OhMyLoveFreeShipping) {
  window.OhMyLoveFreeShipping = (() => {
    let refreshTimer;

    function formatMoney(cents) {
      const amount = Math.round(Number(cents) / 100);

      return `$${new Intl.NumberFormat('es-CL', {
        maximumFractionDigits: 0
      }).format(amount)}`;
    }

    function hexToRgb(hex) {
      let value = String(hex || '').replace('#', '').trim();

      if (value.length === 3) {
        value = value
          .split('')
          .map((char) => char + char)
          .join('');
      }

      if (value.length !== 6) {
        return null;
      }

      const number = parseInt(value, 16);

      return {
        r: (number >> 16) & 255,
        g: (number >> 8) & 255,
        b: number & 255
      };
    }

    function mixColors(colorA, colorB, amount) {
      const a = hexToRgb(colorA);
      const b = hexToRgb(colorB);

      if (!a || !b) {
        return colorA || colorB || '#DF0067';
      }

      const ratio = Math.min(Math.max(amount, 0), 1);

      const r = Math.round(a.r + (b.r - a.r) * ratio);
      const g = Math.round(a.g + (b.g - a.g) * ratio);
      const blue = Math.round(a.b + (b.b - a.b) * ratio);

      return `rgb(${r}, ${g}, ${blue})`;
    }

    function getProgressColor(element, progress) {
      const startColor =
        element.dataset.startColor || '#E53935';

      const middleColor =
        element.dataset.middleColor || '#F2B705';

      const endColor =
        element.dataset.endColor || '#249B55';

      if (progress <= 50) {
        return mixColors(
          startColor,
          middleColor,
          progress / 50
        );
      }

      return mixColors(
        middleColor,
        endColor,
        (progress - 50) / 50
      );
    }

    function renderMessage(element, template, values) {
      const target = element.querySelector(
        '[data-free-shipping-message]'
      );

      if (!target) return;

      target.replaceChildren();

      const parts = template.split(
        /(\[monto\]|\[meta\])/g
      );

      parts.forEach((part) => {
        if (part === '[monto]') {
          const span = document.createElement('span');

          span.className = 'free-shipping__accent';
          span.textContent = values.remaining;

          target.appendChild(span);
        } else if (part === '[meta]') {
          const span = document.createElement('span');

          span.className = 'free-shipping__accent';
          span.textContent = values.goal;

          target.appendChild(span);
        } else {
          target.appendChild(
            document.createTextNode(part)
          );
        }
      });
    }

    function updateElement(element, cart) {
      const goalAmount = Number(
        element.dataset.goal || 0
      );

      if (!goalAmount) return;

      const goal = goalAmount * 100;
      const total = Number(cart.total_price || 0);

      const remaining = Math.max(
        goal - total,
        0
      );

      const progress = Math.min(
        Math.max((total / goal) * 100, 0),
        100
      );

      let state;

      if (cart.item_count === 0) {
        state = 'empty';
      } else if (total >= goal) {
        state = 'success';
      } else {
        state = 'progress';
      }

      element.dataset.state = state;

      const values = {
        remaining: formatMoney(remaining),
        goal: formatMoney(goal)
      };

      let message;

      if (state === 'empty') {
        message =
          element.dataset.emptyText || '';
      } else if (state === 'success') {
        message =
          element.dataset.successText || '';
      } else {
        message =
          element.dataset.progressText || '';
      }

      renderMessage(
        element,
        message,
        values
      );

      const fill = element.querySelector(
        '[data-free-shipping-fill]'
      );

      const icon = element.querySelector(
        '[data-free-shipping-icon]'
      );

      if (fill) {
        fill.style.width = `${progress}%`;
      }

      if (icon) {
        const iconPosition = Math.min(
          Math.max(progress, 2),
          98
        );

        icon.style.left = `${iconPosition}%`;
      }

      /*
       * Color dinámico:
       * 0%   = rojo
       * 50%  = amarillo
       * 100% = verde
       */
      if (element.dataset.mode === 'progress') {
        const progressColor =
          getProgressColor(element, progress);

        element.style.setProperty(
          '--free-shipping-progress-color',
          progressColor
        );
      }

      if (
        element.dataset.mode === 'progress' &&
        cart.item_count === 0
      ) {
        element.hidden = true;
      } else {
        element.hidden = false;
      }
    }

    async function getCart() {
      const root =
        window.Shopify?.routes?.root || '/';

      const response = await fetch(
        `${root}cart.js`,
        {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error(
          'No fue posible obtener el carrito'
        );
      }

      return response.json();
    }

    async function refresh() {
      const elements =
        document.querySelectorAll(
          '[data-free-shipping]'
        );

      if (!elements.length) return;

      try {
        const cart = await getCart();

        elements.forEach((element) => {
          updateElement(element, cart);
        });
      } catch (error) {
        console.warn(
          '[Envío gratis]',
          error
        );
      }
    }

    function scheduleRefresh(delay = 0) {
      window.clearTimeout(refreshTimer);

      refreshTimer = window.setTimeout(
        () => refresh(),
        delay
      );
    }

    function handleCartUpdate(event) {
      if (
        event.promise &&
        typeof event.promise.then === 'function'
      ) {
        event.promise
          .then(() => scheduleRefresh(0))
          .catch(() => scheduleRefresh(250));
      } else {
        scheduleRefresh(250);
      }
    }

    document.addEventListener(
      'shopify:cart:lines-update',
      handleCartUpdate
    );

    document.addEventListener(
      'shopify:cart:discount-update',
      handleCartUpdate
    );

    document.addEventListener(
      'shopify:section:load',
      () => scheduleRefresh(0)
    );
    /*
 * Detecta cuando Horizon crea o vuelve a renderizar
 * el Cart Drawer, especialmente al agregar
 * el primer producto a un carrito vacío.
 */
const freeShippingObserver = new MutationObserver(
  (mutations) => {
    let freeShippingAdded = false;

    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (
          node.matches('[data-free-shipping]') ||
          node.querySelector('[data-free-shipping]')
        ) {
          freeShippingAdded = true;
          break;
        }
      }

      if (freeShippingAdded) break;
    }

    if (freeShippingAdded) {
      scheduleRefresh(0);
    }
  }
);

function startFreeShippingObserver() {
  if (!document.body) return;

  freeShippingObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.body) {
  startFreeShippingObserver();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    startFreeShippingObserver,
    { once: true }
  );
}

    if (
      document.readyState === 'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        refresh
      );
    } else {
      refresh();
    }

    return {
      refresh,
      scheduleRefresh
    };
  })();
}